import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, Stack, Typography, Chip } from "@mui/material";
import { ArrowBack, FolderCopy } from "@mui/icons-material";
import Formularios from "../components/Formularios";
// import auth from "../services/auth";

const FormsAndTemplatesScreen = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{ p: { xs: 2, md: 4 }, background: "#f7f5fb", minHeight: "100vh" }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          mb: 3,
          background: "linear-gradient(90deg, #5b2c72 0%, #7b1fa2 100%)",
          color: "white",
        }}
      >
        <CardContent>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <FolderCopy />
              <Typography variant="h5" fontWeight="bold">
                Formulários e Modelos
              </Typography>
            </Stack>
            <Chip
              label="Voltar"
              color="secondary"
              icon={<ArrowBack fontSize="small" />}
              onClick={() => navigate("/dashboard")}
            />
          </Stack>
        </CardContent>
      </Card>
      <Formularios />
    </Box>
  );
};

export default FormsAndTemplatesScreen;
